module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-shadow-2.4c6b5cfb.png";